import { Button, IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";

/**
 * GenerateEntregaObraOcorrenciaColumnsDefinition
 */

type Props = {
  statusChecklistServico: number | null;
  onActionEditar: (idInformacoesEntregaObraCliente: number | null, idInspecaoObraItens: number | null, openState: boolean) => void;
  onActionDownload: (idInformacoesEntregaObraCliente: number, nroArquivo: number) => void;
  onActionDeletar: (idInformacoesEntregaObraCliente: number | null, openState: boolean) => void;
};

export const GenerateEntregaObraOcorrenciaColumnsDefinition = ({
  statusChecklistServico,
  onActionEditar,
  onActionDownload,
  onActionDeletar,

}: Props): GridColDef[] => {
  const computeStatusTitle = (status: boolean) => {
    switch (status) {
      case false:
        return "Não";
      case true:
        return "Sim";
      default:
        return "?";
    }
  };

  const computeStatusColor = (status: boolean) => {
    switch (status) {
      case false:
        return "#c6c6c6";
      case true:
        return "#45b6af";
      default:
        return "#0303FF";
    }
  };

  const computeStatusDescription = (status: boolean) => {
    switch (status) {
      case false:
        return "Não";
      case true:
        return "Sim";
      default:
        return "?";
    }
  };

  return [
    {
      field: "descricao",
      filterable: false,
      headerName: "Descrição",
      flex: 1,
      width: 200,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className=" w-full h-full flex justify-start break-normal">
            {value}
          </div>
        );
      }
    },
    {
      field: "dataDescricao",
      filterable: false,
      headerName: "Data",
      minWidth: 110,
      sortable: false,
      renderCell: ({ value }) => {
        return <div>{value ? dayjs(value).format('DD/MM/YYYY') : null}</div>
      }
    },
    {
      field: "tratativa",
      filterable: false,
      headerName: "Tratativa",
      flex: 1,
      width: 200,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className=" w-full h-full flex justify-start break-normal">
            {value}
          </div>
        );
      }
    },
    {
      field: "dataTratativa",
      filterable: false,
      headerName: "Data Tratativa",
      minWidth: 110,
      sortable: false,
      renderCell: ({ value }) => {
        return <div>{value ? dayjs(value).format('DD/MM/YYYY') : null}</div>
      }
    },
    {
      field: "nomeItemInspecao",
      filterable: false,
      headerName: "Item de Inspeção",
      flex: 1,
      width: 200,
      minWidth: 200,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className=" w-full h-full flex justify-start break-normal">
            {value}
          </div>
        );
      }
    },
    {
      field: "inspecao",
      filterable: false,
      headerName: "Inspeção",
      minWidth: 100,
      width: 100,
      sortable: false,
    },
    {
      field: "existeArquivo1",
      filterable: false,
      headerName: "Arquivo 1",
      minWidth: 100,
      maxWidth: 100,
      sortable: false,
      valueGetter: (_, row) => ({
        nomeArquivo: row['nomeArquivo'] as string,
        idOcorrencia: row['idInformacoesEntregaObraCliente'] as number,
      }),
      renderCell: ({ value }) => {
        if (!value.nomeArquivo) return <div></div>;
        return (
          <Button
            onMouseDown={() => onActionDownload(value.idOcorrencia, 1)}
            sx={{
              fontSize: 11,
              paddingX: '.4rem',
              paddingY: 0,
              background: '#e6e6e6',
              borderLeft: '.2rem solid #45b6af',
              borderRadius: 0,
              color: 'black',
              fontWeight: 'normal',
            }}>
            Arquivo 1
          </Button>
        );
      },
    },
    {
      field: "existeArquivo2",
      filterable: false,
      headerName: "Arquivo 2",
      minWidth: 100,
      maxWidth: 100,
      sortable: false,
      valueGetter: (_, row) => ({
        nomeArquivo2: row['nomeArquivo2'] as string,
        idOcorrencia: row['idInformacoesEntregaObraCliente'] as number,
      }),
      renderCell: ({ value }) => {
        if (!value.nomeArquivo2) return <div></div>;
        return (
          <Button
            onMouseDown={() => onActionDownload(value.idOcorrencia, 2)}
            sx={{
              fontSize: 11,
              paddingX: '.4rem',
              paddingY: 0,
              background: '#e6e6e6',
              borderLeft: '.2rem solid #45b6af',
              borderRadius: 0,
              color: 'black',
              fontWeight: 'normal',
            }}>
            Arquivo 2
          </Button>
        );
      },
    },
    {
      field: 'idInformacoesEntregaObraCliente',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 120,
      minWidth: 120,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <div className="flex items-center justify-center w-full h-full gap-2">
              <IconButton
                disabled={statusChecklistServico === 1}
                onClick={() => onActionEditar(params.value, null, true)}>
                <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
              </IconButton>

              <IconButton
                disabled={statusChecklistServico === 1}
                onClick={() => onActionDeletar(params.value, true)}>
                <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
              </IconButton>
            </div>
          </div>
        );
      }
    },
  ];
}